
class CapViewAllTransferDates {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_all_transfer_dates'
}

function create(config) {
  return new CapViewAllTransferDates(config)
}

export default {
  key,
  create,
}
